// extracted by mini-css-extract-plugin
export default {"loaderWrapper":"styles_loaderWrapper__1bor3","dots":"styles_dots__y5RpP","dot":"styles_dot__3ye+n","blink":"styles_blink__X2QRq","text":"styles_text__UTzvy"};